export default __webpack_public_path__ + "static/media/productImageOrange.125c07c0.png";